import { connect } from 'react-redux';
import { buildDispatchable } from '../../../actions/_action-utilities';
import externalApplicationActions, { syncActions } from '../../../actions/external-applications';
import history from '../../../history';
import { ExternalAppUserList } from './external-app-user-list';
import { NEW_DESIGN_SUFFIX } from '../../../core/utils/newDesign';
import { cmxRuntime } from '@codametrix/ui-common';
const isNewDesign = cmxRuntime.runtimeOverrides?.newAdminDesign;
const mapStateToProps = function(state) {
    const { externalApplications } = state;
    const items = externalApplications.externalApplicationUserList.sortablePageable.pageableDefinition.content;
    return {
        ...externalApplications.externalApplicationUserList,
        items,
        selectedAppName: externalApplications.selectedExternalApplication.externalApplicationName
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        list: (params)=>{
            runDispatchable(()=>{
                return dispatch(externalApplicationActions.listExternalAppUsers(params));
            });
        },
        onSelection: (item, path)=>{
            runDispatchable(()=>{
                dispatch(syncActions.selectExternalAppUser(item));
                history.push(`${path}/users/edit${isNewDesign ? NEW_DESIGN_SUFFIX : ''}`);
            });
        },
        onAddUser: (path)=>{
            runDispatchable(()=>{
                history.push(`${path}/users/edit${isNewDesign ? NEW_DESIGN_SUFFIX : ''}`);
            });
        },
        setStateToDefault: (defaultUser)=>{
            runDispatchable(()=>{
                return dispatch(syncActions.setStateToDefault(defaultUser));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExternalAppUserList);
